import { ReactNode } from "react";
import { WebLink } from "../../components/contact-components/WebLink/WebLink";
import { AntiochPoster, MissionOrgs } from "../ImageLibrary/imageLibrary";
import { EmailLink } from "../../components/contact-components/EmailLink/EmailLink";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCalendar,
  faMoneyCheckDollar,
} from "@fortawesome/pro-regular-svg-icons";
import { faHandBackPointRight, faLocationDot } from "@fortawesome/pro-solid-svg-icons";

export interface SpeakersAndOpportunitiesInterface {
  date?: string;
  speaker?: string;
  org?: string;
  speakerImage?: string;
  orgImage?: string;
  content: ReactNode;
}

export const SpeakersAndOpportunitiesData: SpeakersAndOpportunitiesInterface[] =
  [
    {
      orgImage: MissionOrgs.Antioch21,
      content:(
        <>
          <div className="content-section">
            <div className="missions-poster">
                <img src={AntiochPoster} alt="Antioch Summit Poster" />
              </div>
            <p>
              This October, Antioch21 invites you to the Antioch Summit — a national missions conference that unites Christian leaders, 
              missionaries, and believers to embrace the Great Commission and catalyse global missions.
            </p>
            <p>
              Inspired by Revelation 7, The 2025 Antioch Summit is open to all as one united people of God and for the Church of Singapore 
              to be inspired for the Decade of Missions. 
            </p>
            </div>
          <div className="content-section">
            <div className="detail-item">
              <FontAwesomeIcon icon={faCalendar} width={15} />{" "}
              <span>Date: </span>2–4 October 2025
            </div>
            <div className="detail-item">
              <FontAwesomeIcon icon={faLocationDot} width={15} />{" "}
              <span>Location: </span>Bartley Christian Church
            </div>
          </div>
          <p>
            <FontAwesomeIcon
              icon={faHandBackPointRight}
              color="orange"
              width={25}
            />{" "}
            Get more details and sign up at <WebLink link="https://antioch21.sg/antioch-summit-2025" />.
          </p>
        </>
      )
    },
    {
      org: "BFECxLoveJapan",
      orgImage: MissionOrgs.LoveJapanImage,
      content: (
        <>
          <p>
            BFEC is partnering with the LoveSingapore churches to reach Japan
            with the gospel of Jesus Christ. (Read) BFEC is led to serve in
            Kyushu alongside pastors connected with the LoveJapan network.
            Please consider joining a vision trip to see how God is working in
            Japan.
          </p>
          <div className="content-section">
            <div className="list-header">Kagoshima 鹿児島</div>
            <ul>
              <li>22–28 October 2025 (Team A)</li>
              <li>29 October – 4 November 2025 (Team B)</li>
            </ul>
            <p className="list-details">
              Open to all BFEC members. Support Pastor Park (previously TWR) in
              church planting — prayer walking, outreach, English teaching,
              cooking, etc.
            </p>
          </div>
          <div className="content-section">
            <div className="list-header">Nagasaki 長崎</div>
            <ul>
              <li>20–26 November 2025 (Young Adults Team)</li>
              <li>27 November – 3 December 2025 (Youth Service Team)</li>
            </ul>
            <p className="list-details">
              Support Nagasaki Baptist Church — prayer walking, outreach,
              international cultural events, etc.
            </p>
          </div>
        </>
      ),
    },
    {
      org: "El Shaddai",
      orgImage: MissionOrgs.ElShaddaiImage,
      content: (
        <>
          <p>
            As part of a long-term partnership with Elshaddai Refugee Centre in
            Malaysia, BFEC is sending a follow-up mission team to Klang from 1–4
            June. Mission trippers will be running an English camp to help
            identified preschool refugee children catch up on their school
            curriculum and build relationships with their families.
          </p>
          <p>
            <FontAwesomeIcon
              icon={faHandBackPointRight}
              color="orange"
              width={25}
            />{" "}
            Sign up now at <WebLink link="bfec.sg/missionssignup" />.
          </p>
        </>
      ),
    },
    {
      org: "Radion",
      orgImage: MissionOrgs.RadionImage,
      content: (
        <>
          <p>
            BFEC started its partnership with RADION when we sent our first
            youth mission team to Phetchabun, Khek Noi to participate in
            RADION's StreetKIDS (STK) program. RADION is a Christian relief &
            development organisation, providing both short term relief
            assistance, as well as long term developmental support for
            vulnerable and needy communities. Its key programmes include
            child-rescue, community development and crisis relief. STK is a
            rescue and recovery programme for children who have suffered abuse
            from high-risk backgrounds.
          </p>
          <p>
            From 22 to 31 March 2025, our second youth mission team (comprising
            13 members) headed out to Khek Noi once again. The mission trip's
            focus was to organize and identify at-risk kids at a 3-day 2-night
            camp. Prior to that, the trippers were trained in the local
            language, culture and on-field interactions. There were also home
            visits where they witnessed and participated in the work RADION does
            with the villagers. The youths deeply benefited from this cross
            cultural perspective and were exposed to the needs of the
            underprivileged.
          </p>
        </>
      ),
    },
    {
      org: "Feed5K",
      orgImage: MissionOrgs.F5KImage,
      content: (
        <>
          <p>
            Be a blessing through volunteering in the neighbourhood! Feed5K
            opportunities include delivering bento meals to the clients served
            by New Hope Community Services, serving needy seniors through
            befriending them, or reaching out to the homeless through outreach
            walks in the evening.
          </p>
          <p>
            <FontAwesomeIcon
              icon={faHandBackPointRight}
              color="orange"
              width={25}
            />{" "}
            Bring your talents and time to serve the less fortunate amongst us.
            If you are interested or have any queries, please email contact us
            at <EmailLink to="feed5k@bfec.org.sg" />.
          </p>
        </>
      ),
    },
    {
      speaker: "Donkey Tracting in Japan",
      org: "TWR",
      orgImage: MissionOrgs.TWRImage,
      content: (
        <>
          <p>
            TWR will be conducting Donkey Tracting mission trips to Japan in
            2025. Participants will visit local Japanese churches, fellowship
            with pastors and believers, and support tract distribution efforts
            in local neighborhoods — all in partnership with local churches, to
            support and promote TWR’s ministry in Japan.
          </p>
          <div className="content-section">
            <div className="detail-item">
              <FontAwesomeIcon icon={faCalendar} width={15} />{" "}
              <span>Date: </span>15–22 September 2025 (Tohoku: Sendai &
              Fukushima)
            </div>
            <div className="detail-item">
              <FontAwesomeIcon icon={faMoneyCheckDollar} width={15} />{" "}
              <span>Cost: </span>SGD $1000–1300 (excluding airfare)
            </div>
          </div>
          <p>
            <FontAwesomeIcon
              icon={faHandBackPointRight}
              color="orange"
              width={25}
            />{" "}
            Get more information at{" "}
            <WebLink link="twr.org/japan-donkey-tracting" /> or contact Jonathan
            at <EmailLink to="jchen@twr.org" />.
          </p>
        </>
      ),
    },
  ];
